import React, { useState } from 'react'
import { Flex, space, PrimaryButton, Select, SelectOption, Text, FormField } from '@workday/canvas-kit-react'
import { Pill } from '@workday/canvas-kit-preview-react'
import { PrimaryButtonColors } from '../../components/CanvasThemes'
import { callTypeFromCode, callTypesForCategories } from '../../models/CallType'
import styled from '@emotion/styled'

export interface ConfigureFeedIncidentTypesSectionProps {
  callTypeIDs: string[]
  onChangeCallTypeIDs: (callTypesIDs: string[]) => void
}

const StyledSelect = styled(Select)`
  min-width: unset!important;
`

const ConfigureFeedIncidentTypesSection = ({
  callTypeIDs,
  onChangeCallTypeIDs
}: ConfigureFeedIncidentTypesSectionProps) => {
  const callTypes = callTypesForCategories([
    'Aid',
    'Aircraft',
    'Alarm',
    'Assist',
    'Explosion',
    'Fire',
    'Hazard',
    'Investigation',
    'Lockout',
    'Medical',
    'Natural Disaster',
    'Rescue',
    'Vehicle',
    'Wires',
    'Other'
  ])
    .filter(calltype => !callTypeIDs.includes(calltype.id))
    .sort((a, b) => a.description.localeCompare(b.description))
  const [selectedCallTypeID, setSelectedCallTypeID] = useState<string>('')
  return (
    <FormField label="Incident Types">
      <Flex flexDirection="column" gap={space.xxs}>
        {callTypeIDs.length > 0 ? (
          <Flex flexDirection="row" flexWrap="wrap" gap={space.xs}>
            {callTypeIDs.map(id => {
              const callType = callTypeFromCode(id)
              return (
                <Pill key={id} variant="removable">
                  <Pill.Label>{callType.description}</Pill.Label>
                  <Pill.IconButton
                    onClick={() => {
                      onChangeCallTypeIDs(callTypeIDs.filter(theID => theID !== id))
                    }}
                  />
                </Pill>
              )
            })}
          </Flex>
        ) : (
          <Text typeLevel="body.small">All incident types currently included</Text>
        )}
        {callTypes.length > 0 && (
          <Flex flexDirection="row" gap={space.xs} alignItems="center">
            <StyledSelect value={selectedCallTypeID} onChange={event => setSelectedCallTypeID(event.currentTarget.value)}>
              {callTypes.map(callType => (
                <SelectOption value={callType.id} key={callType.id} label={callType.description} />
              ))}
            </StyledSelect>
            <PrimaryButton
              size="small"
              colors={PrimaryButtonColors}
              onClick={event => {
                const id = selectedCallTypeID !== '' ? selectedCallTypeID : callTypes[0].id
                onChangeCallTypeIDs([...callTypeIDs, id])
              }}
            >
              Add
            </PrimaryButton>
          </Flex>
        )}
      </Flex>
    </FormField>
  )
}

export default ConfigureFeedIncidentTypesSection
